import { ADMIN_TYPE, BUSINESS_UNIT_TYPE } from "constants/people"

const validate = values => {
  const errors = {}

  // First name required
  if (!values.first_name) {
    errors.first_name = "Required"
  }

  // Last name required
  if (!values.last_name) {
    errors.last_name = "Required"
  }

  // Email address validation
  if (
    !values.email_address ||
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email_address)
  ) {
    errors.email_address = "Invalid Email Address"
  }

  // Assign acount type required
  if (
    values.people_type === ADMIN_TYPE
    && !values.assign_acount_type
    && values.assign_acount_type !== 0
  ) {
    errors.assign_acount_type = "Required"
  }

  // Business unit required
  if (
    values.people_type === ADMIN_TYPE
    && values.assign_acount_type === BUSINESS_UNIT_TYPE
    && !values.business_unit &&
    values.business_unit !== 0
  ) {
    errors.business_unit = "Required"
  }

  // Assign role required
  if (
    values.people_type === ADMIN_TYPE
    && (!values.assign_roles || values.assign_roles.length < 1)
  ) {
    errors.assign_roles = "Required"
  }

  return errors
}

export default (validate)